import { Component, Input } from '@angular/core';
import { ISummaryReport } from '@shared/interfaces';

@Component({
    selector: 'app-summary-report-placeholder',
    templateUrl: './summary-report-placeholder.component.html',
    styleUrls: ['./summary-report-placeholder.component.scss'],
    standalone: false
})
export class SummaryReportPlaceholderComponent {
    @Input() placeholderArray: ISummaryReport[];

    @Input() set countWithDelay(val: { count: number; delay?: number }) {
        setTimeout(
            () => {
                this.placeholderArray = Array<ISummaryReport>(val.count).fill({});
            },
            val.delay ? val.delay : 0
        );
    }
}
